import { UnitsOperationTypeEnum } from './UnitsOperationTypeEnum';

export const UnitsStatusEnum = {
  Available: {
    key: 1,
    value: 'available',
    name: 'Available',
    showInSelect: true,
    classes: 'c-success-light',
    saleCategory: {
      key: 21424,
      value: 'sale-available',
    },
    leaseCategory: {
      key: 21428,
      value: 'leased-available',
    },
    display: 'Available',
  },
  ReservedLeased: {
    key: 2,
    value: 'reserved-for-lease',
    name: 'ReservedLeased',
    showInSelect: true,
    effectedOperationType: UnitsOperationTypeEnum.rent.key,
    classes: 'c-primary',
    category: {
      key: 21429,
      value: 'leased-reserved',
    },
    display: 'Reserved Leased',
  },
  Leased: {
    key: 3,
    value: 'leased',
    name: 'Leased',
    showInSelect: true,
    effectedOperationType: UnitsOperationTypeEnum.rent.key,
    classes: 'c-primary',
    category: {
      key: 21430,
      value: 'leased-leased',
    },
    display: 'Leased',
  },
  LeasedByThirdParty: {
    key: 4,
    value: 'leased-by-third-party',
    name: 'LeasedByThirdParty',
    showInSelect: true,
    effectedOperationType: UnitsOperationTypeEnum.rent.key,
    classes: 'c-primary',
    display: 'Leased By Third Party',
  },
  ReservedSale: {
    key: 5,
    value: 'reserved-for-sale',
    name: 'ReservedSale',
    showInSelect: true,
    effectedOperationType: UnitsOperationTypeEnum.sale.key,
    classes: 'c-primary',
    category: {
      key: 21425,
      value: 'sale-reserved',
    },
    display: 'Reserved Sale',
  },
  Sale: {
    key: 6,
    value: 'sale',
    name: 'Sale',
    showInSelect: true,
    effectedOperationType: UnitsOperationTypeEnum.sale.key,
    classes: 'c-primary',
    category: {
      key: 21426,
      value: 'sale-sold',
    },
    display: 'Sale',
  },
  SaleByThirdParty: {
    key: 7,
    value: 'sale-by-third-party',
    name: 'SaleByThirdParty',
    effectedOperationType: UnitsOperationTypeEnum.sale.key,
    classes: 'c-primary',
    display: 'Sale By Third Party',
  },
  Blocked: {
    key: 8,
    value: 'blocked',
    classes: 'c-black-light',
    name: 'Blocked',
    display: 'Blocked',
  },
  Upcoming: {
    key: 9,
    value: 'upcoming',
    classes: 'c-warning-light',
    name: 'Upcoming',
    display: 'Upcoming',
  },
  Draft: {
    key: 10,
    value: 'draft',
    name: 'Draft',
    classes: 'globel-Gry-style',
    showInSelect: true,
    saleCategory: {
      key: 21423,
      value: 'sale-draft',
    },
    leaseCategory: {
      key: 21427,
      value: 'leased-draft',
    },
    display: 'Draft',
  },
  PendingReserveLease: {
    key: 11,
    value: 'Pendin_Reserve_Lease',
    classes: 'c-pending',
    name: 'PendingReserveLease',
    display: 'Pending Reserve Lease',
  },
  PendingReservedLease: {
    key: 11,
    value: 'Pendin_Reserve_Lease',
    classes: 'c-pending',
    name: 'PendingReservedLease',
    display: 'Pending Reserved Lease',
  },
  PendingLease: {
    key: 12,
    value: 'Pending_Lease',
    classes: 'c-pending',
    name: 'PendingLease',
    display: 'Pending Lease',
  },
  PendingLeased: {
    key: 12,
    value: 'Pending_Lease',
    classes: 'c-pending',
    name: 'PendingLeased',
    display: 'Pending Lease',
  },
  PendingReserveSale: {
    key: 13,
    value: 'Pendin_Reserve_Sale',
    classes: 'c-pending',
    name: 'PendingReserveSale',
    display: 'Pending Reserve Sale',
  },
  PendingSale: {
    key: 14,
    value: 'PendingSale',
    classes: 'c-pending',
    name: 'PendingSale',
    display: 'Pending Sale',
  },
  UnderOffer: {
    key: 15,
    value: 'UnderOffer',
    classes: 'c-pending',
    name: 'UnderOffer',
    display: 'Under Offer',
  },
  OfferSigned: {
    key: 16,
    value: 'OfferSigned',
    classes: 'c-pending',
    name: 'OfferSigned',
    display: 'Offer Signed',
  },
  UnderContract: {
    key: 17,
    value: 'UnderContract',
    classes: 'c-pending',
    name: 'UnderContract',
    display: 'Under Contract',
  },
  ContractSigned: {
    key: 18,
    value: 'ContractSigned',
    classes: 'c-pending',
    name: 'ContractSigned',
    display: 'Contract Signed',
  },
};
